import customAxios from '../../customAxios';
import { ACADEMIC_YEAR } from '../../routes';

// ? Refused by the API while services still belong to the year — deleting one would orphan them.
async function deleteAcademicYear(_id: string) {
  try {
    return (await customAxios.delete(`${ACADEMIC_YEAR}/${_id}`)).data;
  } catch (error: any) {
    console.error({ ACADEMIC_YEAR: error });
  }
}

export default deleteAcademicYear;
